import {
  Paper,
  SimpleGrid,
  TextInput,
  MultiSelect,
  NumberInput,
  Group,
  Button,
  Switch,
  Stack,
  Title,
  Text,
  Loader,
} from "@mantine/core";
import {
  IconSearch,
  IconCalendar,
  IconBuildingStore,
  IconTruckDelivery,
  IconRefresh,
} from "@tabler/icons-react";

export function FilterPanel({
  filters,
  setFilters,
  onSearch,
  onReset,
  loading,
  suppliers,
  warehouses,
  suppliersLoading,
  warehousesLoading,
}) {
  return (
    <Paper>
      <Stack gap="md">
        <div>
          <Title order={4}>Search GRs</Title>
          <Text size="sm" c="dimmed">
            Filter goods receipts from SAP HANA by date, supplier and store.
            Multiple suppliers and stores can be selected.
          </Text>
        </div>

        <SimpleGrid cols={{ base: 1, sm: 2, lg: 4 }} spacing="md">
          <TextInput
            type="date"
            label="From"
            leftSection={<IconCalendar size={16} />}
            value={filters.from}
            onChange={(e) => {
              const v = e?.target?.value ?? e?.currentTarget?.value ?? "";
              setFilters((f) => ({ ...f, from: v }));
            }}
          />
          <TextInput
            type="date"
            label="To"
            leftSection={<IconCalendar size={16} />}
            value={filters.to}
            onChange={(e) => {
              const v = e?.target?.value ?? e?.currentTarget?.value ?? "";
              setFilters((f) => ({ ...f, to: v }));
            }}
          />
          <NumberInput
            label="Result limit"
            description="Max GRs to fetch"
            value={filters.limit}
            onChange={(v) =>
              setFilters((f) => ({ ...f, limit: Number(v) || 200 }))
            }
            min={10}
            max={1000}
            step={50}
          />
          <Switch
            mt={28}
            label="Exclude fresh items"
            description="Hide GRs containing meat, produce, dairy"
            checked={filters.excludeFresh}
            onChange={(e) => {
              const checked =
                e?.target?.checked ?? e?.currentTarget?.checked ?? false;
              setFilters((f) => ({ ...f, excludeFresh: checked }));
            }}
          />
        </SimpleGrid>

        <SimpleGrid cols={{ base: 1, md: 2 }} spacing="md">
          <MultiSelect
            label="Suppliers"
            placeholder={
              suppliersLoading ? "Loading suppliers…" : "All suppliers"
            }
            data={suppliers.map((s) => ({
              value: s.code,
              label: `${s.code} · ${s.name}`,
            }))}
            value={filters.supplierCodes}
            onChange={(v) =>
              setFilters((f) => ({ ...f, supplierCodes: v }))
            }
            searchable
            clearable
            checkIconPosition="right"
            leftSection={<IconTruckDelivery size={16} />}
            rightSection={suppliersLoading ? <Loader size={14} /> : null}
            nothingFoundMessage="No suppliers match"
            maxDropdownHeight={280}
          />
          <MultiSelect
            label="Stores"
            placeholder={
              warehousesLoading ? "Loading stores…" : "All stores"
            }
            data={warehouses.map((w) => ({
              value: w.code,
              label: `${w.code} · ${w.name}`,
            }))}
            value={filters.branchCodes}
            onChange={(v) =>
              setFilters((f) => ({ ...f, branchCodes: v }))
            }
            searchable
            clearable
            checkIconPosition="right"
            leftSection={<IconBuildingStore size={16} />}
            rightSection={warehousesLoading ? <Loader size={14} /> : null}
            nothingFoundMessage="No stores match"
            maxDropdownHeight={280}
          />
        </SimpleGrid>

        <Group justify="flex-end">
          <Button
            variant="default"
            leftSection={<IconRefresh size={16} />}
            onClick={onReset}
            disabled={loading}
          >
            Reset
          </Button>
          <Button
            leftSection={<IconSearch size={16} />}
            onClick={onSearch}
            loading={loading}
          >
            Search GRs
          </Button>
        </Group>
      </Stack>
    </Paper>
  );
}
